'use client';

import { useEffect } from 'react';

import { ampli } from '@/ampli';
import { trackEvent } from '@/configurations/tracking/track';

/**
 * Émet `Destination Viewed` avec le slug de la destination consultée —
 * l'identifiant métier que l'autocapture `[Amplitude] Page Viewed` ne fournit
 * pas, et la clé de breakdown du KPI « destinations les plus vues ».
 */
export function DestinationViewTracker({ destinationSlug }: { destinationSlug: string }) {
    useEffect(() => {
        if (!destinationSlug) return;

        trackEvent(() => ampli.destinationViewed({ destination_slug: destinationSlug }));
    }, [destinationSlug]);

    return null;
}
